
export function setUserId(state, data) {
  state.user_id = data
}

export function setUserAccess(state, data) {
  state.user_access = data
}

export function setIsDev(state, data) {
    state.is_dev = data
}
export function setPrefixMQTT(state, data) {
    state.prefix_mqtt = data
}


export function setPermissions(state, data) {
    state.permissions = data
}




